import { GpThirdParty } from '@/app/editor/iframe/atom/third-party/GpThirdParty';
import type { FormControlSetting } from '@/app/editor/iframe/atom/Atom.model';

const FormControlSettings: Array<FormControlSetting> = [
  {
    type: 'custom:align',
    name: 'alignment',
    targetSelector: '.module',
    property: '',
  },
  {
    type: 'html:extraClass',
    name: 'extra_class',
    targetSelector: '.module',
    property: 'data-exc',
    default_value: '',
  },
  {
    type: 'html:attr',
    name: 'widget',
    refreshType: 'all',
    property: 'data-widget',
    targetSelector: '.module',
    options: [
      {
        key: 'reviews',
        value: 'Reviews',
      },
      {
        key: 'badge',
        value: 'Star Badge',
      },
      {
        key: 'badgeCollection',
        value: 'Star Badge in Collection',
      },
      {
        key: 'carousel',
        value: 'Carousel',
      },
      {
        key: 'masonry',
        value: 'Masonry',
      },
    ],
    default_value: 'reviews',
  },
];
/**
 * GpRyviuProductReviews Class
 */
export class GpRyviuProductReviews extends GpThirdParty {
  public $el: JQuery;
  /**
   * Thông tin riêng của Atom
   * @returns object watch
   */
  getLabel(): string {
    return this.$el.attr('data-label') || 'Ryviu Product Reviews';
  }
  /**
   * override getLabel từ Atom
   * @returns Slug
   */
  getSlug(): string {
    return this.$el.attr('data-slug') || 'ryviu-product-reviews';
  }
  /**
   * getFormControlSettings;
   * @returns setting read/write from left-sidebar to live page
   */
  getFormControlSettings(): Array<FormControlSetting> {
    return FormControlSettings;
  }
  /**
   * check
   * @returns true: change setting after drag
   */
  isAutoRenderSetting() {
    return true;
  }
}
